module.exports = __webpack_public_path__ + "static/media/arrow-right-green-small.934b9f37.svg";